import type { DefineMethods } from 'aspida'
import { mockMethods } from 'aspida-mock'
import type { SupervisorDescriptionSetting } from '~/types/supervisorDescriptionSetting'

export type Methods = DefineMethods<{
    get: {
        resBody: {
            result: SupervisorDescriptionSetting
        }
    }
    put: {
        reqBody: SupervisorDescriptionSetting
        resBody: {
            message: string
        }
    }
}>

export default mockMethods<Methods>({
    get: ({ query }) => ({
        status: 200,
        resBody: {
            result: {
                id: 1,
                company_id: 1,
                value: '所属部門のマネージャー／派遣先の責任者',
                created_at: new Date().toISOString(),
                updated_at: new Date().toISOString(),
            },
        },
    }),
    put: () => ({
        status: 200,
        resBody: {
            message: '直属上司設定を保存しました',
        },
    }),
})
